import useApi from "./useApi";
import useSessionStorage from "./useSessionStorage";

const useFeedback = () => {
    const { postJson } = useApi();
    const { userGetCustomerType } = useSessionStorage();

    /**
     * Function to send feedback json to backend.
     *
     * @returns null if validation fails
     */
    const sendFeedback = async (NPSScore, feedbackTopic, messageInput) => {
        // feedback is not sent if it is not given (no score and/or open feedback)
        if (NPSScore !== null || (feedbackTopic !== "" && messageInput !== "")) {
            // use null for topic and feedback, if they are empty
            const topic = feedbackTopic === "" ? null : feedbackTopic;
            const feedback = messageInput === "" ? null : messageInput;
            const createdAt = new Date().toISOString();
            const customerType = userGetCustomerType();

            const data = JSON.stringify({
                "created_at": createdAt,
                "data": [
                    {
                        "value": NPSScore,
                        "topic": topic,
                        "feedback": feedback,
                        "customer_type": customerType
                    }
                ]
            });

            return await postJson('/online/feedback', data);
        }
        return null;
    }

    return {
        sendFeedback
    }
}

export default useFeedback;
